import {
  InteracLabel,
  LoginHeader,
  PoweredByLabel,
} from "@/components/widget-components";
import { SignupPanel } from "@/panels/signup/SignupPanel";
import { Stepper } from "./Stepper";

const isIframe = window.self !== window.top;

export const Signup = () => {
  const Footer = () => {
    return (
      <div
        className="absolute left-0 right-0 flex justify-center p-4 sm:bottom-0"
        style={{
          top: isIframe
            ? window.innerWidth < 640
              ? "526px"
              : "539px"
            : window.innerWidth < 640
              ? "526px"
              : "660px",
        }}
        data-testid="container-signup-footer"
      >
        <PoweredByLabel />
      </div>
    );
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 max-w-[730px] lg:min-w-[730px] mx-auto min-w-full relative" data-testid="container-signup">
      <LoginHeader data-testid="container-signup-header">
        <Stepper />
      </LoginHeader>
      <div className="flex flex-col flex-grow relative" data-testid="container-signup-content">
        <SignupPanel />
        <Footer />
      </div>
    </div>
  );
};

// Suggestions
// 1. Use CSS modules or styled-components for the inline styles to improve maintainability
// 2. Extract the Footer component to its own file for better organization
// 3. Use a React hook for window dimension detection instead of directly using window.innerWidth
// 4. Consider using a more responsive approach for positioning rather than fixed pixel values
